import * as React from 'react';

interface FormActionsProps {
  children: React.ReactNode;
  align?: 'left' | 'right' | 'center' | 'space-between';
  className?: string;
}

export function FormActions({
  children,
  align = 'right',
  className,
}: FormActionsProps) {
  const alignmentClasses = {
    left: 'justify-start',
    right: 'justify-end',
    center: 'justify-center',
    'space-between': 'justify-between',
  };

  const baseClass = `flex gap-3 ${alignmentClasses[align]}`;
  const finalClass = className ? `${baseClass} ${className}` : baseClass;

  return <div className={finalClass}>{children}</div>;
}
